<template>
  <div class="sidebar-nav">
    <div class="set-platform-info">
      <span class="el-icon-menu"></span>
      <span>代理总后台</span>
    </div>
    <el-menu
      :default-active="$route.path.split('/').pop()"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <dynamicMenu :menuList="menuList" />
    </el-menu>
  </div>
</template>

<script>
import dynamicMenu from "@/components/dynamic-menu";
import { mapState } from "vuex";
export default {
  components: {
    dynamicMenu,
  },
  computed: {
    ...mapState({
      menuList: (state) => state.dynamicRoutesList,
    }),
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style scoped lang="less">
.sidebar-nav{
 height: 100vh;
 background:#545c64;

 .set-platform-info{
  background: #32393f;
  height: 60px;
  padding: 0 20px;
  line-height: 60px;
  font-size: 20px;
  color: #409eff;
  span {
    &:nth-child(2){
      margin-left: 10px;
    }
  }
 }
}
.el-menu {
  border: none; /* 去除边框 */
}

.el-menu::after {
  border: none; /* 去除分割线 */
}
</style>
